<template>
  <path pid="0" d="M16.23 2.28zM21 12a1 1 0 00-1 1v8a1 1 0 01-1 1H7a1 1 0 01-1-1v-8a1 1 0 00-2 0v8a3 3 0 003 3h12a3 3 0 003-3v-8a1 1 0 00-1-1z"/><path pid="1" d="M13 17h.12a1 1 0 00.88-1V5.41l2.29 2.3a1 1 0 001.42-1.42l-4-4-.11-.09-.08-.05H13.35L13.2 2H12.56l-.08.05-.08.07-4 4a1 1 0 000 1.42l.1.08a1 1 0 001.32-.08L12 5.41V16a1 1 0 001 1zM16.94 2.49l.09.08-.08-.08h-.01z"/>
</template>
